/*!
 * @jscrypto/kdfs v0.9.1
 * Copyright 2026 Chen, Yi-Cyuan
 * Released under the MIT license
 */
import { concatBytes } from '@jscrypto/core';

const evpKdf = {
    kind: 'kdf',
    name: 'EvpKDF',
    derive(params, context) {
        const options = params;
        return deriveEvpKdf({
            ...options,
            hash: context.getHash(options.hash ?? 'MD5'),
        });
    },
};
const evpKdfPreset = {
    kind: 'preset',
    name: 'evpkdf',
    components() {
        return [evpKdf];
    },
};
function deriveEvpKdf(params) {
    assertPositiveInteger(params.length, 'EvpKDF length');
    if (params.iterations !== undefined) {
        assertPositiveInteger(params.iterations, 'EvpKDF iterations');
    }
    if (params.input === undefined || params.input === null) {
        throw new TypeError('EvpKDF requires input.');
    }
    if (params.salt === undefined || params.salt === null) {
        throw new TypeError('EvpKDF requires salt.');
    }
    const password = toBytes(params.input);
    const salt = toBytes(params.salt);
    const blocks = [];
    let previous = new Uint8Array(0);
    let length = 0;
    while (length < params.length) {
        let block = params.hash.hash(concatBytes(previous, password, salt));
        for (let i = 1; i < (params.iterations ?? 1); i++) {
            block = params.hash.hash(block);
        }
        blocks.push(block);
        previous = block;
        length += block.length;
    }
    return concatBytes(...blocks).slice(0, params.length);
}
function toBytes(input) {
    return typeof input === 'string' ? new TextEncoder().encode(input) : input;
}
function assertPositiveInteger(value, label) {
    if (!Number.isInteger(value) || value <= 0) {
        throw new RangeError(`${label} must be a positive integer.`);
    }
}

export { deriveEvpKdf, evpKdf, evpKdfPreset };
//# sourceMappingURL=evpkdf.mjs.map
